import { NotificationInfoOutlineIcon } from '@tableau/icons/NotificationInfoOutlineIcon';
import { TextLinkWidget, Tooltip } from '@tableau/widgets';
import React from 'react';

import { HelpService } from '~commonInfra/services/HelpService';

import { Messages } from '../../../codegen/Localize';
import { SettingsSection } from '../../components/common/SettingsSection';
import { componentRegistryEntry } from '../../general-settings/components/SettingsComponentRegistryFunctions';
import { learnMoreStyle } from '../../styles/CommonStyles';
import { DataConnectSiteSettingsProps } from '../DataConnectSiteSettings';
import { DataConnectMultiClusterSection } from './dataConnectMultiCluster/DataConnectMultiClusterSection';

export function DataConnectClustersAndNodesSection(props: DataConnectSiteSettingsProps) {
  const maxNodes: string = props.baasEdgePoolsAndClusters.maxNodes?.toString();
  const nodesCount: string = props.baasEdgePoolsAndClusters.nodesCount?.toString();
  const siteCountOfTenant: string = props.baasEdgePoolsAndClusters.siteCountOfTenant?.toString();
  return <>
    <div style={{paddingBottom: 12}}>
      <span style={{fontSize: 15, fontWeight: 700}}>{Messages.dataConnectSiteSettingsClustersAndNodes()}</span>
      <span style={{paddingLeft: 10, fontSize: 14, fontWeight: 350}}>{Messages.dataConnectSiteSettingsClustersAndNodesNodenumber({ NODE_NUMBER: nodesCount, MAX_NODES: maxNodes })}</span>
      <span style={{paddingLeft: 4, verticalAlign: 'text-top'}}>
        <Tooltip children={<NotificationInfoOutlineIcon size={14} alt={''} />}
               tooltipContent={
                renderTooltip(
                Messages.dataConnectSiteSettingsClustersAndNodesNodenumberTooltip({ NODE_NUMBER: nodesCount, MAX_NODES: maxNodes, TOTAL_SITES: siteCountOfTenant }))}
               position={Tooltip.defaultProps.position!}
               afterDelay={false}
               followCursor={false} />
      </span>

    </div>
    <SettingsSection title={''}
      testId={'DataConnect-ClustersAndNodes-section'}
      description={renderDescription()}>
      <DataConnectMultiClusterSection
        clusters={props.baasEdgePoolsAndClusters.userClusters}
        sharedClusters={props.baasEdgePoolsAndClusters.sharedClusters}
        siteId={props.settings.siteId}
        refreshPoolsAndClusters={props.refreshPoolsAndClusters}
        hasLoadedPoolsAndClusters={props.hasLoadedPoolsAndClusters}
        allowCreateCluster={props.baasEdgePoolsAndClusters.allowCreateCluster}
      />
    </SettingsSection>
  </>;
}

function renderDescription() {
  return <>
    <span>{Messages.dataConnectSiteSettingsClustersAndNodes_description()}</span>
    <TextLinkWidget testId={'DataConnect-ClustersAndNodes-learn-more'}
      className={learnMoreStyle}
      href={HelpService.getServerHelpUrlByCategory('DataConnect-ClustersAndNodes')}
      target={'_blank'}>
      {Messages.siteRemoteAgentSettingsLearnMore()}
    </TextLinkWidget>
  </>;
}

function renderTooltip(text: string) {
  return <div >
    <span style={{display:'block'}}>{text}</span>
  </div>;
}

/* for registering the component in settings registry */
export const DataConnectClustersAndNodesSectionSpecs = componentRegistryEntry({
  name: 'DataConnectClustersAndNodesSection',
  component: DataConnectClustersAndNodesSection
});
